import { useEffect, useState } from "react";
import Icon from "./Icon";

const DISMISS_KEY = "tf_install_dismissed";

function isStandalone() {
  return window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
}
function isIOS() {
  return /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream;
}

// Floating "Instalar app" affordance — bottom-left (mirrors the scroll-to-top
// button, which lives bottom-right). Android/Chrome gets the native install
// prompt via beforeinstallprompt; iOS Safari has no such API, so it gets a
// short one-time hint on how to "Agregar a pantalla de inicio" manually.
export default function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showIosHint, setShowIosHint] = useState(false);
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(DISMISS_KEY) === "1");

  useEffect(() => {
    if (isStandalone() || dismissed) return;
    const onPrompt = (e) => { e.preventDefault(); setDeferredPrompt(e); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    if (isIOS()) setShowIosHint(true);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, [dismissed]);

  const dismiss = () => { localStorage.setItem(DISMISS_KEY, "1"); setDismissed(true); };

  const install = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
    dismiss();
  };

  if (dismissed || isStandalone()) return null;
  if (!deferredPrompt && !showIosHint) return null;

  return (
    <div className="fixed bottom-6 left-6 z-40 flex max-w-xs items-center gap-2 rounded-2xl border border-slate-200 bg-white px-3.5 py-2.5 shadow-pop">
      <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-gradient-to-br from-brand-500 to-brand-700 text-[11px] font-bold text-white">
        G<span style={{ color: "#6ab234" }}>+</span>
      </span>
      {deferredPrompt ? (
        <>
          <span className="text-xs font-medium text-slate-600">Instala GestionIT en tu dispositivo</span>
          <button onClick={install} className="btn-primary h-8 shrink-0 px-2.5 text-xs"><Icon name="download" size={13} /> Instalar</button>
        </>
      ) : (
        <span className="text-xs font-medium text-slate-600">
          Toca <Icon name="share" size={12} className="inline -mt-0.5" /> y luego "Agregar a inicio" para instalar la app
        </span>
      )}
      <button onClick={dismiss} className="shrink-0 text-slate-300 hover:text-slate-500" title="Cerrar"><Icon name="x" size={14} /></button>
    </div>
  );
}
